import { useState, useEffect } from 'react';
import { SearchResponse } from '../../../types/SearchBar';
import { searchService } from '../Navbar/SearchService';

export function useDebouncedSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState<SearchResponse>({
    suggestions: [],
    totalResults: 0,
    searchTerm: ''
  });
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setSuggestions({ suggestions: [], totalResults: 0, searchTerm: '' });
      setIsOpen(false);
      return;
    }

    const delayDebounceFn = setTimeout(async () => {
      setLoading(true);
      try {
        const results = await searchService.getSuggestions(searchTerm);
        setSuggestions(results);
        setIsOpen(true);
      } catch (error) {
        console.error('Search error:', error);
        setSuggestions({ suggestions: [], totalResults: 0, searchTerm });
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const clearSearch = () => {
    setSearchTerm('');
    setSuggestions({ suggestions: [], totalResults: 0, searchTerm: '' });
    setIsOpen(false);
  };

  return {
    searchTerm,
    setSearchTerm,
    suggestions,
    loading,
    isOpen,
    setIsOpen,
    clearSearch
  };
}














